'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  message: {
    backgroundColor: _colors2.default.white,
    borderRadius: '4px',
    boxSizing: 'border-box',
    color: _colors2.default.primaryText,
    maxWidth: '80%',
    padding: '12px',
    position: 'relative',
    wordBreak: 'break-word',
    fontWeight: 'inherit'
  },
  avatar: {
    marginLeft: '48px'
  },
  myAvatar: {
    marginLeft: '0',
    marginRight: '48px'
  },
  myMessage: {
    backgroundColor: _colors2.default.theme,
    color: _colors2.default.white
  },
  body: {
    color: _colors2.default.primaryText,
    fontSize: '16px',
    lineHeight: '22px',
    margin: '0'
  },
  compact: {
    marginLeft: '0',
    marginRight: '0',
    maxWidth: '100%',
    display: 'flex'
  },
  iconMenu: {
    position: 'absolute',
    top: '4px',
    right: '4px'
  }
};
module.exports = exports.default;